module.exports = __webpack_public_path__ + "static/media/home_grid_item_10.cd31eaad.png";